import { html } from 'lit';
import { MobxLitElement } from '@adobe/lit-mobx';
import { customElement, property } from 'lit/decorators.js';
import '@digital-realty/ix-icon-button/ix-icon-button.js';
import { TWStyles } from '../../tw.js';
import { ConfirmationDialogEventDetail } from '../../constants/notification-types.js';
import { NotificationsStyle } from '../../styles/notifications-style.js';

@customElement('confirmation-dialog')
export class ConfirmationDialog extends MobxLitElement {
  static get styles() {
    return [TWStyles, NotificationsStyle];
  }

  @property({ type: String, attribute: true }) textMessage = 'Are you sure?';

  @property({ type: Boolean, attribute: true }) open = false;

  onClick(selectedvalue: Boolean) {
    const event = new CustomEvent<ConfirmationDialogEventDetail>(
      'on-confirm-selection',
      {
        detail: { returnValue: selectedvalue },
        bubbles: true,
        composed: true,
      }
    );
    this.dispatchEvent(event);
  }

  dialogClosed = () => {
    this.dispatchEvent(new CustomEvent('confirm-dialog-closed'));
    this.onClick(false);
  };

  render() {
    return html` <ix-dialog
      ?open=${this.open}
      class="w-[580px]"
      @closed=${this.dialogClosed}
    >
      <div slot="headline">${this.textMessage}</div>
      <div slot="actions">
        <div class="flex flex-row justify-end p-1">
          <ix-button
            name="cancel"
            appearance="text"
            @click="${() => this.onClick(false)}"
            >DISMISS</ix-button
          >
          <ix-button
            name="confirm"
            appearance="text"
            @click="${() => this.onClick(true)}"
            >YES</ix-button
          >
        </div>
      </div>
    </ix-dialog>`;
  }
}
